import React from 'react';
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ isAllowed, redirectTo, children }) => {
    return isAllowed ? children : <Navigate to={redirectTo} replace />;
};

export default PrivateRoute;
